export default __webpack_public_path__ + "static/media/portfolio-hover-205.347f938e.jpg";